import { isValid } from 'date-fns';

import { DataDimension, Parameters, ReportType } from '../../backend';

export function createRouterQueryParams(bp: Parameters): {
    [key: string]: string;
} {
    const params: URLSearchParams = new URLSearchParams();

    params.set('data_source', bp.dataSource);

    if (bp.periodType?.id != null) {
        params.set('period_type', String(bp.periodType.id));
    }

    if (isValid(bp.startDate)) {
        params.set('start_date', bp.startDate.toJSON());
    }

    if (isValid(bp.endDate)) {
        params.set('end_date', bp.endDate.toJSON());
    }

    switch (bp.reportType) {
        case ReportType.Role:
            params.set('report_type', bp.reportType);
            if (bp.roles?.[0]?.id != null) {
                params.set('role', String(bp.roles[0].id));
            }
            if (bp.sites?.[0]?.id != null) {
                params.set('site', String(bp.sites[0].id));
            }
            switch (bp.dataDimension) {
                case DataDimension.SuperGroup:
                    if (bp.superGroups?.[0]?.id != null) {
                        params.set('super_group', String(bp.superGroups[0].id));
                    }
                    break;
                case DataDimension.Queue:
                    if (bp.queues?.[0] != null) {
                        params.set('queue', String(bp.queues[0].id));
                    }
                    break;
            }
            break;
        case ReportType.Team:
            params.set('report_type', bp.reportType);
            if (bp.teams?.[0]?.id != null) {
                params.set('team', String(bp.teams[0].id));
            }
            if (bp.queues?.[0]?.id != null) {
                params.set('queue', String(bp.queues[0].id));
            }
            break;
        case ReportType.Individual:
            params.set('report_type', bp.reportType);
            if (bp.individuals?.[0]?.id != null) {
                params.set('individual', String(bp.individuals[0].id));
            }
            if (bp.individuals?.[0]?.id != null) {
                params.set('queue', String(bp.individuals[0].id));
            }
            break;
    }

    if (bp.metrics?.length > 0) {
        params.set('metrics', bp.metrics.map((e) => e.id).join(','));
    }

    return Object.fromEntries(params.entries());
}
